import React, { useState, useEffect } from 'react'
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { compareAsc, format } from 'date-fns'
import moment from "moment";
function HolidayReportComp() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const [errcountry, setErrcountry] = useState('')
    const [country, setCountry] = useState('');
    const [countrylist, setCountrylist] = useState([]);
    const [year, setYear] = useState('')
    const [erryear, setErryear] = useState('')
    const arr_country = ['', 'India', 'USA', 'UK', '', 'Sweden', 'Singapore', 'Australia', 'Spain', 'Hongkong', 'Mexico']
    const controller = new AbortController();
    useEffect(() => {
        const getCountryList = async () => {
            try {
                const response = await fetch(`${SERVER_URL}api/common/country_list`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token.value}`
                    },
                    signal: controller.signal
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status} - ${response.statusText}`);
                }

                const data = await response.json();

                if (data.status) {
                    setCountrylist(data.result);
                } else {
                    console.error("Failed to fetch country list:", data);
                }
            } catch (error) {
                console.error("Error fetching country list:", error);
            }
        };
        getCountryList()
        const cancelRequest = () => {
            controller.abort();
        };
    }, [])

    const [loader, setLoader] = useState(false)
    const Download_Holiday_Report = () => {
        setErrcountry('')
        setErryear('')
        if (country == '') {
            setErrcountry('red');
        } else if (year == '') {
            setErryear('red')
        }
        else {
            downloadHolidayReport()
            setLoader(true)
        }
    }
    const downloadHolidayReport = async () => {
        setLoader(true); // Start loading indicator
        const controller = new AbortController(); // Add cancellation if needed
        const signal = controller.signal;

        try {
            // Initialize Excel workbook
            const workbook = await XlsxPopulate.fromBlankAsync();
            const sheet = workbook.sheet(0);

            // Table Headers
            const newArray = [
                [`${year} ${arr_country[country]} Holidays`, '', '', ''],
                ['On Account of', 'DATE', 'DAY', 'HOLIDAY TYPE']
            ];

            // Fetch holiday data
            const response = await fetch(`${SERVER_URL}api/reports/companyHoliday?comp=${country}&&year=${year}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token.value}`
                },
                signal
            });

            if (!response.ok) throw new Error(`Error: ${response.status} - ${response.statusText}`);

            const data = await response.json();

            // Process the data
            data?.results.forEach(item => {
                newArray.push([
                    item.holiday_name,
                    moment(item.holiday_date).format("DD MMM, YYYY"),
                    moment(item.holiday_date).format("ddd"),
                    item.Holiday_type
                ]);
            });

            // Write data to the sheet
            newArray.forEach((row, rowIndex) => {
                row.forEach((cell, colIndex) => {
                    const cellRef = sheet.cell(rowIndex + 1, colIndex + 1);
                    cellRef.value(cell);

                    if (rowIndex === 0) {
                        cellRef.style({
                            bold: true,
                            fontSize: 16,
                            fill: 'aed9ff', // Yellow background
                            horizontalAlignment: 'center',
                        });
                    } else if (rowIndex === 1) {
                        cellRef.style({
                            bold: true,
                            fontSize: 12,
                            fill: 'aed9ff',
                            border: true,  // Enables borders
                            borderColor: "000000", // Sets the border color (black in hex)
                            borderStyle: "thin"
                        });
                    }
                });
            });

            // Merge title row & set column widths
            sheet.range("A1:D1").merged(true);
            [22, 20, 20, 22].forEach((width, i) => sheet.column(i + 1).width(width));

            // Generate and trigger download
            const blob = await workbook.outputAsync();
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `${arr_country[country]}_Holidays_List_${year}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating holiday report:", error);
        } finally {
            setLoader(false); // Stop loading indicator
        }
    };

    // Function to cancel the request if needed
    const cancelRequest = () => controller.abort();
    return (
        <div className="tab-pane" style={{ display: 'block' }}>
            <div className='row'>
                <div className='col-md-3'>
                    <div className='form-blk'>
                        <div className='form-label'>Country</div>
                        <div className='form-input'>
                            <select style={{ 'borderColor': `${errcountry}` }} className="form-select" value={country} onChange={e => setCountry(e.target.value)} >
                                <option value="">Select Country</option>
                                {
                                    countrylist?.map((item, ind) => {
                                        return <option key={ind} value={item.id}>{item.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className='col-md-3'>
                    <div className='form-blk'>
                        <div className='form-label'>Year</div>
                        <div className='form-input'>
                            <select style={{ 'borderColor': `${erryear}` }} className="form-select" value={year} onChange={e => setYear(e.target.value)}>
                                <option value=''>Select Year</option>
                                <option value='2023'>2023 Year</option>
                                <option value='2024'>2024 Year</option>
                                <option value='2025'>2025 Year</option>
                                <option value='2026'>2026 Year</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className='col-md-3'>
                    <div className='form-blk'>
                        <label className="h22"></label>
                        <div className='form-input'>
                            <button className="btn_5" onClick={Download_Holiday_Report} disabled={loader} >{loader == true && <i className='fa fa-circle-o-notch fa-spin mr05'></i>}Download</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default HolidayReportComp
